$(function () {
  $('[data-search-textfield]').on('keypress', function (ev) {
    if (ev.which == 13) {
      searchBackend();
    }
  });
});

function searchBackend() {
  var searchValue = $('[data-search-textfield]').val().trim();

  if (!searchValue) {
    window.location.href = '/admin';
    return;
  }

  window.location.href = '/admin/?s=' + searchValue;
}
